var exports = {
  "k": "x43aef4ae--fe7144--container",
};

module.exports = exports;
